
import React, { createContext, useState, useContext } from 'react';
const StoreContext = createContext();
export const StoreProvider = ({ children }) => {
  const [stores, setStores] = useState([]);
  const [isMultipleStore, setIsMultipleStore] = useState(false);
  const [currentStoreId, setCurrentStoreId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refreshStores = () => {
    setRefreshTrigger(prev => prev + 1);
  };
  return (
    <StoreContext.Provider
      value={{
        stores,
        setStores,
        isMultipleStore,
        setIsMultipleStore,
        currentStoreId,
        setCurrentStoreId,
        refreshStores,
        refreshTrigger 
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);